module.exports = __webpack_public_path__ + "static/media/website.07f75200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website.png
// module id = 690
// module chunks = 0